import {
  DEFAULT_THEME,
  isValidHexColor,
  normalizeHexColor,
} from "../../theme/companyTheme";
import ThemeContrastWarning from "./ThemeContrastWarning";

export default function ThemeColorField({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  defaultColor,
  showContrastWarning = true,
}) {
  const fallback = defaultColor || DEFAULT_THEME.primary;
  const normalizedValue = normalizeHexColor(value, fallback);
  const displaySwatch = isValidHexColor(value) ? value.toUpperCase() : normalizedValue;

  return (
    <div className="mb-3">
      <label className="form-label fw-2 mb-2 d-flex align-items-center gap-2" htmlFor={`${name}-hex`}>
        <span
          aria-hidden="true"
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "4px",
            background: displaySwatch,
            border: "1px solid #e0e0e0",
            flexShrink: 0,
          }}
        />
        {label}
      </label>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <input
          type="color"
          id={`${name}-picker`}
          value={normalizedValue}
          onChange={(event) => onChange?.(event.target.value.toUpperCase())}
          aria-label={`${label} picker`}
          style={{
            width: "48px",
            height: "48px",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            padding: "4px",
            cursor: "pointer",
            background: "#fff",
          }}
        />
        <input
          type="text"
          id={`${name}-hex`}
          name={name}
          value={value || ""}
          onChange={(event) => onChange?.(event.target.value)}
          onBlur={onBlur}
          placeholder="#RRGGBB"
          className="form-control"
          style={{ maxWidth: "140px", background: "#fafafa", fontFamily: "monospace" }}
          spellCheck={false}
        />
      </div>
      {error ? (
        <div className="text-danger small mt-1">
          {typeof error === "string" ? error : "Enter a valid hex color (#RRGGBB)"}
        </div>
      ) : null}
      {!error && value && !isValidHexColor(value) ? (
        <div className="text-danger small mt-1">Enter a valid 6-digit hex color (#RRGGBB)</div>
      ) : null}
      {showContrastWarning ? <ThemeContrastWarning color={value} /> : null}
    </div>
  );
}
